export function frontHero() {
  const slider = document.querySelector(".front-hero__title-slider");
  if (!slider || slider.__frontHeroInit) return;
  slider.__frontHeroInit = true;

  const slides = Array.from(slider.querySelectorAll(".front-hero__title-slide"));
  if (!slides.length) return;

  let i = 0;
  let timer = null;
  let ro = null;

  const toMeasure = (el) => el.querySelector(".text-reveal") || el;

  function setHeight() {
    const h = toMeasure(slides[i]).offsetHeight || 0;
    slider.style.height = h + "px";
  }

  function observeActive() {
    if (ro) ro.disconnect();
    ro = new ResizeObserver(() => setHeight());
    ro.observe(toMeasure(slides[i]));
  }

  function show(nextIndex) {
    slides[i].classList.remove("active");
    i = nextIndex % slides.length;
    slides[i].classList.add("active");
    observeActive();
    // 1 frame wachten zodat layout klaar is
    requestAnimationFrame(setHeight);
  }

  // Init
  slides.forEach(s => s.classList.remove("active"));
  slides[0].classList.add("active");
  observeActive();
  setHeight();

  // Eenvoudige loop
  clearInterval(timer);
  timer = setInterval(() => show(i + 1), 2500);

  // Hoogte bijschalen bij viewport-wijziging
  window.addEventListener("resize", setHeight, { passive: true });
}
